<template>
  <div class="comment-show">
    <div v-if="info.state" class="comment-info">
      <div class="student-item"> 
        <div class="student-img">
          <img :src="defalutPicUrl"/>
        </div>
        <div class="student-name"> {{ info.name }}</div>
      </div>
      <div class="lesson-info">
        <div class="time-date"> {{ info.currentTime }} {{ info.startTime }}-{{ info.stopTime }} </div>
        <div class="lessonName"> {{ info.lessonName }} </div>
        <div class="teacher-name"> {{ info.teacher }} </div>
      </div>
      <div class="info-box">
        <div class="title-text"> 评论详情 </div>
        <div class="teacher-info">
          <div class="teacher-img">
           <img :src="info.teacherPic ? info.teacherPic : defalutPicUrl"/>
          </div>
          <div class="name-time">
            <div class="name"> {{ info.teacher }} </div>
            <!-- <div class="time"> {{ info.time }} </div> -->
          </div>
          <!-- <div class="arrive">学员已读</div> -->
        </div>
        <div class="praise-satar-component" v-if="info.lessonItemList.length">
          <div v-for="(item, index) in info.lessonItemList" :key="index" class="praise-start-item" :class="{ borderBottomNone :index+1 === info.lessonItemList.length }">
            <div class="praise-start-name"> {{ item.name }} </div>
            <div class="praise-start-target">
              <div v-for="(item_min, index_min) in 5" :key="index_min" class="start-icon">
                <img v-if="index_min+1 <= item.startsCount" src="@assets/images/bright-start.png"/>
                <img v-else src="@assets/images/extinct-start.png"/>
              </div>
            </div>
          </div>
        </div>
        <div class="comment-text">{{ info.commentText }}</div>
        <div class="pic-show-box">
          <div v-for="(item, index) in info.picUrlList" :key="index" class="pic-url" :class="{ noImgPic: item.type !== 1}">
            <img v-if="item.type === 1" :src="item.url"/>
            <video v-if="item.type === 3" :src="item.url" controls/>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  import { commentInfoDesc } from '@api/grade'
  import { getFlieType, addZoo } from '@common'

  export default {
    name: 'CommentShow',
    data() {
      return {
        defalutPicUrl: require('@assets/images/1.jpg'),
        info: {}
      }
    },
    methods: {
      fileType(url) { //检测文件类型
        let type = getFlieType(url);
          if (type === 'image') { //图片
            return 1;
          }else if (type === 'radio') { //音乐
            return 2;
          }else if (type === 'video') { //视频
            return 3;
          }else {
            return 0;
          }
      },
      /**
       * get data
       */
      getCommentInfoDesc(params) {
        let form = {
            lesson_id: params.lessonId,
            teacher_id: params.teacherId,
            student_id: params.id
          }
        commentInfoDesc(form).then(this.setInfoData);
      },
      setInfoData(res) {
          let result = res.data.information[0];
          let infoStore = {
            name: result.name,
            teacher: result.staff_name,
            // time: '昨天20:12',
            teacherPic: result.staff_name_avatar,
            commentText: result.contentname,
            currentTime: `${new Date(Number(result.datatime+'000')).getFullYear()}-${addZoo(new Date(Number(result.datatime+'000')).getMonth()+1)}-${addZoo(new Date(Number (result.datatime+'000')).getDate())}`,
            startTime: result.start_time,
            stopTime: result.stop_time,
            lessonName: result.lesson,
            state: true,
          }
          let picUrlList = [];
          if (result.video_images.length && Array.isArray(result.video_images)) {
            picUrlList = result.video_images.map(item => {
              return {
                url: item,
                type: this.fileType(item)
              }
            })
          }
          infoStore.picUrlList = picUrlList;
          let startList = [];
          if (result.template.length && Array.isArray(result.template)) {
            startList = result.template.map(item => {
              return {
                name: item.template,
                startsCount: item.starlevel
              }
            })
          }
          infoStore.lessonItemList = startList;
          this.info = infoStore;
        }
    },
    mounted() {
      let params = this.$route.query;
      this.getCommentInfoDesc(params);
    }
  }
</script>

<style scoped>
.comment-show {
  height: 100vh;
  width: 100vw;
  background-color: white;
  position: relative;
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  font-size: 16px;

}
.comment-info {
  padding-bottom: 50px;
}
  .student-item {
    padding: 10px;
    display: flex;
    border-top: 1px solid #f3f3f3;
    align-items: center;
  }
    .student-img, .teacher-img {
      width: 50px;
      height: 50px;
      overflow: hidden;
      border-radius: 50%;
      margin-right: 15px;
    }
      .student-img img, .teacher-img img {
        width: 100%;
        height: 100%;
      }
    .name-time, .name-time > div {
      display: flex;
      align-items: center;
    }
    .student-name {
      display: flex;
      flex: 1;
      align-items: center;
    }
      .arrive {
        font-size: 13px;
        display: flex;
        align-items: center;
        margin-left: 10px;
        border: 1px solid #b5b3b3;
        color: #8c8c8c;
        height: 18px;
        padding: 0 5px;
        border-radius: 2px;
      }
  .lesson-info {
    padding: 0 10px;
    color: #9f9ea0;
    font-size: 14px;
  }
  .title-text {
    padding: 10px;
    font-size: 17px;
  }
  .teacher-info {
    display: flex;
    padding: 0 10px;
  }
      .time {
        margin-top: 3px;
        font-size: 14px;
        color: #b2b0b5;    
      }
  .praise-satar-component {
    background-color: white;
    margin-bottom: 10px;
    font-size: 15px;
  }
    .praise-start-item {
      padding: 10px;
      border-bottom: 1px solid #faf5fb;
      display: flex;
      justify-content: space-between;
    }
      .praise-start-target {
        display: flex;
      }
        .start-icon {
          margin: 0 2px;
        }
          .start-icon img {
            width: 25px;
            height: 25px;
          }
    .borderBottomNone {
      border-bottom: none;
    }
  .comment-text {
    padding: 10px;
  }
  .pic-show-box {
    display: flex;
    flex-wrap: wrap;
  }
    .pic-url {
      width: 33.33%;
      height:33.33vw;
      padding: 5px;
    }
    .noImgPic {
      width: 100%;
      height: 200px;
    }
      .pic-url img, .pic-url video {
        height: 100%;
        width: 100%;
      }
</style>